import ff from './ff';

export default class c50d {

static d_defs = {

/*
  DROP TABLE t_c50r;
  CREATE TABLE t_c50r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER,
    c50rc11s TEXT,
    c50rk11s TEXT,
    c50rc31s TEXT,
    c50rt11s TEXT,
    c50ri11i INTEGER,
    c50ri12i INTEGER,
    c50ri11s TEXT,
    c50ri21s TEXT,
    c50ri31s TEXT,
    c50rcx1i INTEGER,
    c50rcy1t TEXT,
    c50rcy1f INTEGER,
    c50rcz1i INTEGER
  );

  -- 共通機能

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00010100', 'ホーム画面説明文', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00010200', 'ホーム画面説明文2', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00020100', 'ホーム画面直接予約説明文1', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00020200', 'ホーム画面直接予約説明文2', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00020300', 'ホーム画面直接予約説明文3', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00030100', 'ホーム画面エントリー説明文1', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00030200', 'ホーム画面エントリー説明文2', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00030300', 'ホーム画面エントリー説明文3', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00040100', 'ホーム画面設定説明文1', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00040200', 'ホーム画面設定説明文2', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('その他', '00050100', 'メール署名', 'Inp2', 10, 40, '', '', 800, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('その他', '00050200', '通知用メールアドレス', 'Inp', 1, 20, '', '', 800, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('その他', '00050310', 'スタッフによる登録のメール通知', 'Pck', 1, 10, '[{"key":"10","pfx":"あり"},{"key":"0","pfx":"なし"}]', '10', 800, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('その他', '00060100', '利用規約の表記', 'Inp', 1, 10, '', '利用規約', 800, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('その他', '00070100', '設備の使用', 'Pck', 1, 10, '[{"key":"10","pfx":"使用"},{"key":"0","pfx":"不使用"}]', '0', 800, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ログイン', '00080100', '団体用ログイン画面説明文', 'Inp2', 10, 40, '', '', 100, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ログイン', '00080200', '団体のログイン可否', 'Pck', 1, 10, '[{"key":"10","pfx":"可"},{"key":"0","pfx":"不可"}]', '10', 100, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00090100', 'ホーム画面優先エントリー説明文1', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00090200', 'ホーム画面優先エントリー説明文2', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用ホーム', '00090300', 'ホーム画面優先エントリー説明文3', 'Inp2', 10, 40, '', '', 200, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('その他', '00100100', '決済の使用', 'Pck', 1, 10, '[{"key":"10","pfx":"使用"},{"key":"0","pfx":"不使用"}]', '0', 800, '2000-01-01 00:00:00', 1, 10);

  -- 直接予約
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01010100', '団体用直接予約一覧画面説明文', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01010200', '団体用直接予約一覧画面説明文2', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01010300', '団体用直接予約一覧画面説明文3', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01020100', '団体用直接予約登録画面説明文（新規）', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01020200', '団体用直接予約登録画面説明文2（新規）', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01020300', '団体用直接予約登録画面説明文3（新規）', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01021100', '団体用直接予約登録画面説明文（変更）', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01021200', '団体用直接予約登録画面説明文2（変更）', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01021300', '団体用直接予約登録画面説明文3（変更）', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01022100', '団体用直接予約登録画面説明文（閲覧）', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01022200', '団体用直接予約登録画面説明文2（閲覧）', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01022300', '団体用直接予約登録画面説明文3（閲覧）', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01030100', '利用申請書説明文1', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01030101', '利用申請書説明文1色', 'Inp', 1, 10, '', 'black', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01030200', '利用申請書説明文2', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01030201', '利用申請書説明文2色', 'Inp', 1, 10, '', 'black', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01030300', '利用申請書説明文3', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01030301', '利用申請書説明文3色', 'Inp', 1, 10, '', 'black', 300, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01040100', '抽選後の予約解禁日', 'Inp', 1, 10, '', '20', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01040200', '抽選後の予約解禁時刻', 'Inp', 1, 10, '', '15:00', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01040300', 'キャンセル可能日数', 'Inp', 1, 10, '', '7', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01040400', '予約受付終了日数', 'Inp', 1, 10, '', '2', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01040500', '支払日基準', 'Pck', 1, 10, '[{"key":"10","pfx":"利用日"},{"key":"20","pfx":"申請日"}]', '10', 300, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01040600', '支払期限日数', 'Inp', 1, 1, '', '0', 300, '2000-01-01 00:00:00', 1, 10);
  -- UPDATE t_c50r SET c50ri12i = 10 where c50rc11s = '01040500';
  -- UPDATE t_c50r SET c50ri11s = '[{"key":"10","pfx":"利用日"},{"key":"20","pfx":"申請日"}]' where c50rc11s = '01040500';

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('直接予約', '01050100', '直接予約メール文', 'Inp2', 10, 40, '', '', 300, '2000-01-01 00:00:00', 1, 10);

  -- エントリー
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02010100', '団体用エントリー一覧画面説明文', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02010200', '団体用エントリー一覧画面説明文2', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02010300', '団体用エントリー一覧画面説明文3', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02020100', '団体用エントリー登録画面説明文（新規）', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02020200', '団体用エントリー登録画面説明文2（新規）', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02020300', '団体用エントリー登録画面説明文3（新規）', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02021100', '団体用エントリー登録画面説明文（変更）', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02021200', '団体用エントリー登録画面説明文2（変更）', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02021300', '団体用エントリー登録画面説明文3（変更）', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02022100', '団体用エントリー登録画面説明文（閲覧）', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02022200', '団体用エントリー登録画面説明文2（閲覧）', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02022300', '団体用エントリー登録画面説明文3（閲覧）', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02030100', 'エントリーメール文', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);
  -- INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  -- VALUES ('エントリー', '02030200', 'エントリーメール文2', 'Inp2', 10, 40, '', '', 400, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02040100', 'エントリー受付開始日', 'Inp', 1, 10, '', '1', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02040200', 'エントリー受付終了日', 'Inp', 1, 10, '', '10', 400, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー', '02040300', 'エントリー可能件数', 'Inp', 1, 10, '', '2', 400, '2000-01-01 00:00:00', 1, 10);

  -- エントリー抽選
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー抽選', '03010100', 'エントリー抽選結果公開日', 'Inp', 1, 10, '', '15', 500, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー抽選', '03010200', 'エントリー抽選結果公開時刻', 'Inp', 1, 10, '', '15:00', 500, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('エントリー抽選', '03020100', 'エントリー抽選結果メール文', 'Inp2', 10, 40, '', '', 500, '2000-01-01 00:00:00', 1, 10);
  -- INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  -- VALUES ('エントリー抽選', '03020200', 'エントリー抽選結果メール文（落選）', 'Inp2', 10, 40, '', '', 500, '2000-01-01 00:00:00', 1, 10);

  -- 使用状況
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('サイネージ', '04010100', 'サイネージ表示文', 'Inp2', 10, 40, '', '', 600, '2000-01-01 00:00:00', 1, 10);

  -- 団体登録
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('団体用設定', '05010100', '団体用設定画面説明文', 'Inp2', 10, 40, '', '', 700, '2000-01-01 00:00:00', 1, 10);

  -- 優先エントリー
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06010100', '団体用優先エントリー一覧画面説明文', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06010200', '団体用優先エントリー一覧画面説明文2', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06010300', '団体用優先エントリー一覧画面説明文3', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06020100', '団体用優先エントリー登録画面説明文（新規）', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06020200', '団体用優先エントリー登録画面説明文2（新規）', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06020300', '団体用優先エントリー登録画面説明文3（新規）', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06021100', '団体用優先エントリー登録画面説明文（変更）', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06021200', '団体用優先エントリー登録画面説明文2（変更）', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06021300', '団体用優先エントリー登録画面説明文3（変更）', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06022100', '団体用優先エントリー登録画面説明文（閲覧）', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06022200', '団体用優先エントリー登録画面説明文2（閲覧）', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06022300', '団体用優先エントリー登録画面説明文3（閲覧）', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06030100', '優先エントリーメール文', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);
  -- INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  -- VALUES ('優先エントリー', '06030200', '優先エントリーメール文2', 'Inp2', 10, 40, '', '', 450, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06040100', '優先エントリー受付開始日', 'Inp', 1, 10, '', '1', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06040200', '優先エントリー受付終了日', 'Inp', 1, 10, '', '10', 450, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー', '06040300', '優先エントリー可能件数', 'Inp', 1, 10, '', '2', 450, '2000-01-01 00:00:00', 1, 10);

  -- 優先エントリー抽選
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー抽選', '07010100', '優先エントリー抽選結果公開日', 'Inp', 1, 10, '', '15', 550, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー抽選', '07010200', '優先エントリー抽選結果公開時刻', 'Inp', 1, 10, '', '15:00', 550, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  VALUES ('優先エントリー抽選', '07020100', '優先エントリー抽選結果メール文', 'Inp2', 10, 40, '', '', 550, '2000-01-01 00:00:00', 1, 10);
  -- INSERT INTO t_c50r (c50rk11s, c50rc11s, c50rc31s, c50rt11s, c50ri11i, c50ri12i, c50ri11s, c50ri21s, c50rcx1i, c50rcy1t, c50rcy1f, c50rcz1i) 
  -- VALUES ('優先エントリー抽選', '07020200', '優先エントリー抽選結果メール文（落選）', 'Inp2', 10, 40, '', '', 550, '2000-01-01 00:00:00', 1, 10);

  -- UPDATE t_c50r SET _fst = _key where c50rc11s = '05010100';
  UPDATE t_c50r SET _fst = _key;

*/

  c50r: {
    0: {
      pfx: '設定項目',
      b_vsn: false,
      dd_fldDefss: {
        c50rc11s: {
          pfx: '設定項目ID',
          type: 'Inp',
          n_col: 10,
        },
        c50rk11s: {
          pfx: '設定分類',
          type: 'Inp',
          n_col: 10,
        },
        c50rc31s: {
          pfx: '設定項目',
          type: 'Inp',
          n_col: 22,
        },
        c50rt11s: {
          pfx: '設定形式',
          type: 'Pck',
          n_col: 4,
          ld_iss: [
            { key: 'Inp', pfx: '入力（単一行）'},
            { key: 'Inp2', pfx: '入力（複数行）'},
            { key: 'Pck', pfx: '選択'}
          ]
        },
        c50ri11i: {
          pfx: '行数（高さ）',
          type: 'Inp',
          n_col: 4,
        },
        c50ri12i: {
          pfx: '列数（横幅）',
          type: 'Inp',
          n_col: 4,
        },
        c50ri11s: {
          pfx: '区分値',
          type: 'Inp',
          n_col: 4,
        },
        c50ri21s: {
          pfx: '初期値',
          type: 'Inp',
          n_col: 4,
        },
        c50ri31s: {
          pfx: '説明文',
          type: 'Inp',
          n_col: 4,
        },
      },
    }
  },

};

};
